import {OccasionType} from '../../../gql/pwa/graphql.ts';
import styles from '../occasion_details.module.scss';

interface OwnProps {
    occasion: OccasionType;
}
export function Description({occasion}: OwnProps) {
    return (
        <div>
            <p className={styles.occasion_description}>{occasion.description}</p>
        </div>
    );
}
